// ZoomContext.jsx
import React, { createContext, useContext, useState, useEffect } from "react";

const ZoomContext = createContext();

export const ZoomProvider = ({ children }) => {
  const [zoom, setZoom] = useState(
    parseFloat(localStorage.getItem("app-zoom")) || 1
  );

  useEffect(() => {
    document.documentElement.style.fontSize = `${zoom * 16}px`;
    localStorage.setItem("app-zoom", zoom);
  }, [zoom]);

  const resetZoom = () => setZoom(1);

  return (
    <ZoomContext.Provider value={{ zoom, setZoom, resetZoom }}>
      {children}
    </ZoomContext.Provider>
  );
};

// Hook to use zoom anywhere
export const useZoom = () => useContext(ZoomContext);
